// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const BankFeedsPage = lazy(() => import('./pages/BankFeedsPage'));
const TransactionMatchingPage = lazy(() => import('./pages/TransactionMatchingPage'));
const ManualReconciliationPage = lazy(() => import('./pages/ManualReconciliationPage'));
const BankRulesPage = lazy(() => import('./pages/BankRulesPage'));
const FraudDetectionPage = lazy(() => import('./pages/FraudDetectionPage'));
const MultiCurrencyReconPage = lazy(() => import('./pages/MultiCurrencyReconPage'));
const BalanceCertificationPage = lazy(() => import('./pages/BalanceCertificationPage'));

export const BankRoutes: RouteObject = {
  path: 'bank',
  element: <ModuleGuard moduleId="finance.bank" />,
  children: [
    { path: 'bank-feeds', element: <BankFeedsPage />, handle: { crumb: 'Bank Feeds' } },
    { path: 'transaction-matching', element: <TransactionMatchingPage />, handle: { crumb: 'Transaction Matching' } },
    { path: 'manual-reconciliation', element: <ManualReconciliationPage />, handle: { crumb: 'Manual Reconciliation' } },
    { path: 'bank-rules', element: <BankRulesPage />, handle: { crumb: 'Bank Rules' } },
    { path: 'fraud-detection', element: <FraudDetectionPage />, handle: { crumb: 'Fraud Detection' } },
    { path: 'multi-currency-recon', element: <MultiCurrencyReconPage />, handle: { crumb: 'Multi Currency Recon' } },
    { path: 'balance-certification', element: <BalanceCertificationPage />, handle: { crumb: 'Balance Certification' } },
  ],
};
